import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, Button, Modal, Form } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import DataTable from "react-data-table-component";
import { Link } from 'react-router-dom';
import { getSupports, destroySupport } from '../../api/feedbackSupportService';
import { sendMail } from "../../api/revenueService";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { reportSchema } from "../../validations/authSchema";
export default function Support() {
  const [searchText, setSearchText] = useState('');
  const [supports, setSupports] = useState([]);
  const [show, setShow] = useState(false);
  const [sent, setSent] = useState(false);
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');
  const [selectedSupportId, setSelectedSupportId] = useState(null);
  const [supportToDelete, setSupportToDelete] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(reportSchema),
  });

  const handleClose = () => setShow(false);
  const senttoggle = () => setSent(!sent);

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Open':
        return {
          backgroundColor: 'rgba(40, 199, 111, 0.12)',
          color: '#28c76f',
          padding: '5px 10px',
          borderRadius: '5px',
          display: 'inline-block'
        };
      case 'In Progress':
        return {
          backgroundColor: 'rgba(234, 69, 89, 0.12)',
          color: '#EA4559',
          padding: '5px 10px',
          borderRadius: '5px',
          display: 'inline-block'
        };
      case 'Closed':
        return {
          backgroundColor: 'rgba(146, 0, 0, 0.12)',
          color: '#920000',
          padding: '5px 10px',
          borderRadius: '5px',
          display: 'inline-block'
        };
      default:
        return {};
    }
  };

  const fetchSupports = () => {
    getSupports()
      .then((response) => {
        if (response.data) {
          setSupports(response.data);
        }
      })
      .catch((error) => console.error("Error fetching supports", error));
  };

  useEffect(() => {
    fetchSupports();
  }, []);

  const handleDeleteSupport = () => {
    if (!supportToDelete) return;

    destroySupport(supportToDelete)
      .then((response) => {
        if (response.data) {
          setSupports((prevSupports) => prevSupports.filter((support) => support._id !== supportToDelete));
          setShow(false);
          setSupportToDelete(null);
        }
      })
      .catch((error) => {
        console.error("Error deleting support", error);
        alert("Failed to delete support. Please try again.");
      });
  };

  const handleShowDeleteModal = (id) => {
    setSupportToDelete(id);
    setShow(true);
  };

  const handleSendMessage = (data) => {
    try {
      data.email = email;
      data.supportId = selectedSupportId;
      sendMail(data)
        .then((response) => {
          if (response.code === 200) {
            toast.success(response.message);
            setSent(false);
            setEmail('');
            setSubject('');
            setContent('');
            fetchSupports(); 
          }else{
            toast.error(response.message);
          }
        })
        .catch((error) => {
          console.error("Error sending mail", error.response ? error.response.data : error.message);
          toast.error("Failed to send email. Please try again.");
        });
    } catch (error) {
      toast.error(error.message);
    }
  };
    
  


  const handleOpenSendMessage = (row) => {
    console.log("Opening message for support ID:", row._id); // Log the ID for verification

    setEmail(row.userId.email);
    setSelectedSupportId(row._id); // This line should set the ID correctly
    setSent(true);
  };

  const columns = [
    {
      name: 'ID',
      wi: '130px',
      selector: row => row._id,
      sortable: true,
      cell: (row) => row._id
    },
    {
      name: 'User',
      width: '180px',
      selector: row => row.userId.fullName,
      sortable: true,
      cell: (row) => row.userId.fullName
    },
    {
      name: 'Issue Description',
      width: '270px',
      selector: row => row.description,
      sortable: true,
      cell: (row) => row.description
    },
    {
      name: 'Date Submitted',
      width: '180px',
      selector: row => new Date(row.createdAt).toLocaleDateString(),
      sortable: true,
      cell: (row) => new Date(row.createdAt).toLocaleDateString()
    },
    {
      name: 'Status',
      width: '150px',
      selector: row => row.status,
      sortable: true,
      cell: (row) => <span style={getStatusStyle(row.status)}>{row.status}</span>
    },
    {
      name: 'Actions',
      width: '150px',
      cell: (row) => (
        <>
          <Link className="btnview" to={`/admin/support-detail/${row._id}`}>
            <Icon icon="tabler:eye"></Icon>
          </Link>
          <Link className="btnedit" onClick={() => handleOpenSendMessage(row)}>
            <Icon icon="lucide:message-square"></Icon>
          </Link>
          <Link className="btndelete" onClick={() => handleShowDeleteModal(row._id)}>
            <Icon icon="tabler:trash"></Icon>
          </Link>
        </>
      ),
    }
  ];

  const filteredData = supports.filter(
    item => {
      const searchStr = searchText.toLowerCase();
      return (
        item.userId.fullName.toLowerCase().includes(searchStr) ||
        item.description.toLowerCase().includes(searchStr) ||
        item.status.toLowerCase().includes(searchStr) ||
        item._id.toLowerCase().includes(searchStr)
      );
    }
  );

  return (
    <React.Fragment>
      <Card>
        <Card.Header className="py-4">
          <h5>Support</h5>
        </Card.Header>
        <Card.Body>
          <div className="text-end mb-3">
            <input
              type="text"
              placeholder="Search..."
              className="searchfield"
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
            />
          </div>
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            responsive
            className="custom-table"
          />
        </Card.Body>
      </Card>
      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button onClick={handleClose} className="btn btn-primary-outline px-4 me-3">
            Cancel
          </Button>
          <Button className="btn btn-primary px-4 min_width110" onClick={handleDeleteSupport}>
            Ok
          </Button>
        </Modal.Body>
      </Modal>

      <Modal show={sent} onHide={senttoggle} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="modalhead">Send Message</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form onSubmit={handleSubmit(handleSendMessage)}>
            <Form.Group className="mb-3 form-group">
              <Form.Label>Subject</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter subject"
                {...register("subject")}
              />
              {errors.subject && (
                <p className="text-danger">{errors.subject.message}</p>
              )}
            </Form.Group>
            <Form.Group className="mb-3 form-group">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Enter message"
                {...register("content")}
              />
              {errors.content && (
                <p className="text-danger">{errors.content.message}</p>
              )}
            </Form.Group>
            <Button onClick={senttoggle} className="btn btn-secondary px-4 min_width110">
              Cancel
            </Button>
            <Button type="submit" className="btn btn-primary px-4 mx-2 min_width110">
              Send
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
